import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';
import { unregister } from './serviceWorker';
import { Auth0Provider } from './helpers/react-auth0-spa.js';
import { config } from './config/auth.config';
import history from './helpers/history';

// A function that routes the user to the right place
// after login
const onRedirectCallback = (appState: any) => {
  history.push(
    appState && appState.targetUrl
      ? appState.targetUrl
      : window.location.pathname
  );
};

ReactDOM.render(
  <Auth0Provider
    domain={config.domain}
    client_id={config.clientId}
    redirect_uri={window.location.origin}
    // @ts-ignore // TODO: replace react-auth0-spa.js with tsx version
    onRedirectCallback={onRedirectCallback}
  >
    <App />
  </Auth0Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
unregister();
